import { useOpenStateStore } from '../stores/OpenStateStore';

export function useTailorIsOpen() {
  const isOpen = useOpenStateStore((state) => state.isOpen);
  const setIsOpen = useOpenStateStore((state) => state.setIsOpen);

  return { isOpen, setIsOpen };
}
